// extracted by mini-css-extract-plugin
export default {"BillOfMaterials":"BillOfMaterials_BillOfMaterials__hZdyB","proxy":"BillOfMaterials_proxy__cB20S","arrow":"BillOfMaterials_arrow__EVziT","total":"BillOfMaterials_total__tH-Ee"};